import { Injectable, inject } from '@angular/core';
import { httpsCallable, Functions } from "@angular/fire/functions";


@Injectable({
    providedIn: 'root'
})
export class FunctionsService {

  private functions: Functions = inject(Functions);

  constructor(
  ) { }
  
  callFunction(functionName, data) {
    return new Promise(async (resolve, reject) => {
      const func = httpsCallable(this.functions, functionName);
      try {
        const res = await func(data);
        resolve(res.data);
      } catch (error) {
        reject(error)
      }
    })
  }
}